export default "__VITE_ASSET__0FPX92gI__"